import { TRANSACTIONS_STATUS_LIST } from '../../../constants/statuses';
import { GLOBAL_EXPORT_BUTTON_ENABLED } from '../../../constants/user';

export const INITIAL_FILTERS_STATE = {
  email: '',
  user_id: '',
  type: '',
  status: '',
  date_from: '',
  date_to: '',
  sort_by: 'created_at',
  order: 'desc',
};

export const EXPORT_BUTTON_ENABLED = [
  ...GLOBAL_EXPORT_BUTTON_ENABLED,
  'svyatoslav.svyatsky@redtrack.io',
  'olga@redtrack.io',
];

export const TRANSACTIONS_TYPE_LIST = [
  {
    value: '',
    label: 'None',
  },
  {
    value: 'bundle',
    label: 'Add-on',
  },
  {
    value: 'bundle_upgrade',
    label: 'Add-on upgrade',
  },
  {
    value: 'bundle_recurring',
    label: 'Add-on recurring',
  },
  {
    value: 'credits',
    label: 'Credits',
  },
  {
    value: 'recurring',
    label: 'Subscription recurring',
  },
  {
    value: 'reactivate',
    label: 'Subscription reactivate',
  },
  {
    value: 'upgrade',
    label: 'Subscription upgrade',
  },
  {
    value: 'subscription',
    label: 'Subscription',
  },
  {
    value: 'manual_invoice',
    label: 'Manual invoice',
  },
  {
    value: 'special_offer',
    label: 'Special offer',
  }
];

export const TRANSACTIONS_FIELDS = [
  {
    type: 'textField',
    label: 'Email',
    name: 'email',
    placeholder: 'Search by email',
    className: 'main',
  },
  {
    type: 'textField',
    label: 'User ID',
    name: 'user_id',
    placeholder: 'Search by user id',
    className: 'main',
  },
  {
    type: 'select',
    label: 'Type',
    name: 'type',
    placeholder: 'type',
    options: TRANSACTIONS_TYPE_LIST,
    className: 'basic',
  },
  {
    type: 'select',
    label: 'Status',
    name: 'status',
    placeholder: 'Status',
    options: TRANSACTIONS_STATUS_LIST,
    className: 'basic',
  },
  {
    type: 'date',
    label: 'Date from',
    name: 'date_from',
    className: 'date',
  },
  {
    type: 'date',
    label: 'Date to',
    name: 'date_to',
    className: 'date',
  },
];
